import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// Assign Pusher to window for Laravel Echo
window.Pusher = Pusher;

export const initializeEcho = (jwtToken) => {
  if (!jwtToken) {
    return null;
  }

  const config = {
    broadcaster: 'reverb',
    key: process.env.REACT_APP_REVERB_APP_KEY || '8ksyfqvhbbnf0vqitcxn',
    wsHost: process.env.REACT_APP_REVERB_HOST || 'api.tinubu-ambode.org',
    wsPort: parseInt(process.env.REACT_APP_REVERB_PORT) || 8080,
    wssPort: parseInt(process.env.REACT_APP_REVERB_PORT) || 8080,
    forceTLS: (process.env.REACT_APP_REVERB_SCHEME || 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    disableStats: true,

    authEndpoint: `${process.env.REACT_APP_API_URL || 'https://api.tinubu-ambode.org'}/api/v1/broadcasting/auth`,
    auth: {
      headers: {
        'Authorization': `Bearer ${jwtToken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    },
  };

  try {
    return new Echo(config);
  } catch (error) {
    return null;
  }
};

export default initializeEcho;